import * as React from 'react';

export default function ChevronDownIcon({ width, height, color, className, style }) {
  const _width = width ?? 29;
  const _height = height ?? _width;
  const _color = color ?? 'white';

  return (
    <svg
      width={_width}
      height={_height}
      viewBox={`0 0 ${_width} ${_height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M20.937 9.76753C21.1673 9.59101 21.5 9.75517 21.5 10.0453V13.5966C21.5 13.7054 21.4493 13.8081 21.363 13.8743L14.5 19.1359L7.63705 13.8743C7.55065 13.8081 7.5 13.7054 7.5 13.5966V10.0453C7.5 9.75517 7.83271 9.59101 8.06295 9.76753L14.5 14.7026L20.937 9.76753Z"
        fill={_color}
      />
    </svg>
  );
}
